export default __webpack_public_path__ + "static/media/avatar-loading-xxl.bd4ed809.svg";